export default function(selector) {
  return function() {
    return this.matches(selector);
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-transition/~/d3-selection/src/matcher.js
// module id = Zua9
// module chunks = 0